import { RadioButtonUnchecked } from '@mui/icons-material';
import CheckCircleTwoTone from '@mui/icons-material/CheckCircleTwoTone';
import classNames from 'classnames/bind';
import { IconButton } from '@mui/material';
import { ReactNode } from 'react';
import DisabledTooltip from '@components/DisabledTooltip';

import styles from '../RenderCell.module.css';
const stylesContext = classNames.bind(styles);

interface CheckboxCell {
	value?: boolean;
	defaultValue?: boolean;
	className?: string;
}

/**
 * Cell that renders Checkbox/boolean value
 */
export default function CheckboxCell({ value, defaultValue = false, ...props }: CheckboxCell) {
	const cellStyles = stylesContext({
		[props.className ?? '']: Boolean(props.className)
	});

	return (
		<div className={cellStyles}>
			{value || (value === undefined && defaultValue) ? (
				<CheckCircleTwoTone
					color='success'
					className={styles['checkbox']}
				/>
			) : (
				<RadioButtonUnchecked className={styles['checkbox']} />
			)}
		</div>
	);
}

interface CheckboxButtonCellProps extends CheckboxCell {
	onClick: (isReleased: boolean) => void;
	title?: string | ReactNode;
	disabled?: boolean;
	fontSize?: 'small';
}

/**
 * Cell that renders Checkbox/boolean value
 */
export function CheckboxButtonCell({ value, ...props }: CheckboxButtonCellProps) {
	const cellStyles = stylesContext({
		'checkbox-cell': true,
		[props.className ?? '']: Boolean(props.className)
	});

	return (
		<DisabledTooltip
			message={props.title}
			className={cellStyles}
		>
			<IconButton
				type='button'
				onClick={(event) => {
					// prevent unselecting the row when clicking on the checkbox
					event.stopPropagation();
					props.onClick(!value);
				}}
				disabled={props.disabled}
			>
				{value ? (
					<CheckCircleTwoTone
						color='success'
						className={styles['checkbox']}
						fontSize={props.fontSize}
					/>
				) : (
					<RadioButtonUnchecked
						className={styles['checkbox']}
						fontSize={props.fontSize}
					/>
				)}
			</IconButton>
		</DisabledTooltip>
	);
}
